import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { get, set, del } from 'idb-keyval';

// IndexedDB-backed AsyncStorage shim for TanStack Query persistence. The
// query cache is rehydrated on app load so previously-fetched data is
// available offline, then refetched in the background when online.

const idbStorage = {
  getItem: async (key: string) => (await get<string>(key)) ?? null,
  setItem: async (key: string, value: string) => {
    await set(key, value);
  },
  removeItem: async (key: string) => {
    await del(key);
  },
};

export const queryPersister = createAsyncStoragePersister({
  storage: idbStorage,
  key: 'tender-query-cache-v1',
  // Throttle persist writes so a burst of cache updates doesn't thrash IDB.
  throttleTime: 1_000,
});
